<div id="add-society" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase uk-margin-bottom">
                    Ajouter un nouveau<br>adhérent
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Nom de l'adhérent</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="society.Name" (ngModelChange)="validator()" placeholder="Mercure Hôtel Toulouse"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Adresse</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="society.Address" (ngModelChange)="validator()" placeholder="86 Chemin Teynier, 31300 Toulouse"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Numéro de téléphone</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="society.Mobile" (ngModelChange)="validator()" placeholder="06 70 55 17 22"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Code adhérent</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="society.Code" (ngModelChange)="validator()" placeholder="VOP-MERCURE"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="validated === false" (click)="submit()" class="button bold uk-margin-small-left" type="button">
                    Ajouter
                </button>
            </p>
        </div>
    </div>
</div>